// Helper per mostrare nome+cognome del player rosa quando un record EA
// è agganciato a un giocatore della squadra. Fallback sul gamertag/proName originale.

// Fix mojibake lato client: gli snapshot EA salvati prima del fix in
// sync-ea-club / search-ea-clubs contengono stringhe già transcodificate
// male (es. "DÃ NÃ GA GAMING" invece di "DÀ NÀ GA GAMING"). Rileviamo il
// pattern (caratteri tipici Ã / Â / â) e proviamo a invertire la doppia
// decodifica: code unit → byte latin-1 → decode UTF-8 strict.
// Se la stringa non corrisponde al pattern o la decodifica non è UTF-8
// valido, restituiamo la stringa originale.
export function fixEaText(s: string | null | undefined): string {
  if (!s || typeof s !== "string") return s ?? "";
  if (!/[ÃÂâÅž]/.test(s)) return s;
  try {
    const bytes = new Uint8Array(s.length);
    for (let i = 0; i < s.length; i++) {
      const code = s.charCodeAt(i);
      if (code > 0xff) return s;
      bytes[i] = code;
    }
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch {
    return s;
  }
}

export type EaLinkRosterRow = {
  id: string;
  display_name: string;
  ea_sports_id?: string | null;
  ea_account_handle?: string | null;
};

// Sorgente unica dei campi che identificano un player nei record EA: usata sia
// in resolveEaPlayerName (record → player) sia in recordMatchesPlayer (player → record).
function recordHandlesLower(record: any): string[] {
  return [record?.name, record?.playername, record?.proName]
    .filter(Boolean)
    .map((v: string) => String(v).toLowerCase());
}

// Sorgente unica dei campi del player rosa che fanno match con un record EA.
export function buildPlayerEaCandidates(player: {
  ea_sports_id?: string | null;
  ea_account_handle?: string | null;
}): string[] {
  const out: string[] = [];
  if (player.ea_sports_id) out.push(player.ea_sports_id);
  if (player.ea_account_handle) out.push(player.ea_account_handle);
  return Array.from(new Set(out.map((v) => v.toLowerCase()))).filter(Boolean);
}

export function buildRosterLookup(roster: EaLinkRosterRow[]): Map<string, EaLinkRosterRow> {
  const map = new Map<string, EaLinkRosterRow>();
  for (const r of roster) {
    for (const handle of buildPlayerEaCandidates(r)) map.set(handle, r);
  }
  return map;
}

export function resolveEaPlayerName(record: any, lookup: Map<string, EaLinkRosterRow>) {
  for (const c of recordHandlesLower(record)) {
    const hit = lookup.get(c);
    if (hit) return { displayName: hit.display_name, linkedPlayerId: hit.id, linked: true };
  }
  const fallback = record?.proName || record?.playername || record?.name || "—";
  return { displayName: String(fallback), linkedPlayerId: null, linked: false };
}

// Vero se il record EA appartiene al player con i candidates passati.
// candidates va passato gia' lowercased (es. via buildPlayerEaCandidates).
export function recordMatchesPlayer(record: any, candidatesLower: string[]): boolean {
  if (candidatesLower.length === 0) return false;
  const handles = recordHandlesLower(record);
  return handles.some((h) => candidatesLower.includes(h));
}
